import { render, staticRenderFns } from "./CategoryTile.vue?vue&type=template&id=75ad0450&scoped=true&"
import script from "./CategoryTile.vue?vue&type=script&lang=ts&"
export * from "./CategoryTile.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryTile.vue?vue&type=style&index=0&id=75ad0450&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ad0450",
  null
  
)

export default component.exports